import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../../../api';
import {
    Button,
    Input,
    Container,
    Row,
    Col,
    FormGroup,
    Alert,
    Spinner
} from "reactstrap";
import Cookies from 'js-cookie';

const EditMaterialDelivery = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [updateValue, setupdateValues] = useState({
        product_id: id,
        product_name: '',
        available_stock: '',
        total_stock: '',
        cost: ''
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);
                const company_id = Cookies.get('company_id');
                const response = await api.get(`ViewStockSTM.php?id=${id}&company_id=${company_id}`);
                const { product } = response.data;
                
                if (!product) {
                    throw new Error('Product data not found');
                }

                setupdateValues(prevState => ({
                    ...prevState,
                    product_name: product.product_name || '',
                    available_stock: product.available_stock || '',
                    total_stock: product.total_stock || '',
                    cost: product.cost || '',
                }));
            } catch (err) {
                console.error("Error fetching data:", err);
                setError(err.message || 'Failed to fetch product data');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
    
        try {
            const company_id = Cookies.get('company_id');
            const response = await api.post(`edititemsSTM.php?company_id=${company_id}`, updateValue);
            console.log("Data sent successfully:", response.data);
    
            if (response.data.status === 'success') {
                window.history.back();
            } else {
                setError(response.data.message || 'Update was not successful');
            }
        } catch (error) {
            console.error("Error submitting data:", error);
            setError(error.message || 'Failed to update product');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setupdateValues((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    if (loading) {
        return (
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Container className="py-4 text-center">
                    <Spinner color="light" />
                    <p className="text-white mt-2">Loading...</p>
                </Container>
            </div>
        );
    }

    if (error) {
        return (
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Container className="py-4">
                    <Alert color="danger">
                        {error}
                    </Alert>
                    <Link to="/store-admin/store-management/employees4">
                        <Button className='mt-3'>Back</Button>
                    </Link>
                </Container>
            </div>
        );
    }

    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Col className="order-xl-2 mb-5 mb-xl-0 text-center mb-5">
                    <h1>Edit Material Return</h1>
                </Col>
                <Link to="/store-admin/store-management/employees4">
                    <Button className='ml-5'>Back</Button>
                </Link>
                <Container className="py-4">
                    <div className="p-4 rounded" style={{ backgroundColor: 'white', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', border: '1px solid black' }}>
                        <Row className='px-3'>
                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-status">Item Name</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-name"
                                        type="text"
                                        name="product_name"
                                        onChange={handleInputChange}
                                        value={updateValue.product_name}
                                    />
                                </FormGroup>
                            </Col>
                            
                            <Col md={12}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-manager">Current Stock</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-manager"
                                        type="number"
                                        name='available_stock'
                                        onChange={handleInputChange}
                                        value={updateValue.available_stock}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-starting">Total Stock</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-starting"
                                        type="text"
                                        name="total_stock"
                                        onChange={handleInputChange}
                                        value={updateValue.total_stock}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <label className="form-control-label" htmlFor="input-ending">Cost</label>
                                    <Input
                                        className="form-control-alternative"
                                        id="input-ending"
                                        type="number"
                                        name="cost"
                                        onChange={handleInputChange}
                                        value={updateValue.cost}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' className='text-center mb-2'>
                                <Button color="primary" type="submit" onClick={handleSubmit}>Submit</Button>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default EditMaterialDelivery;
